import AdminUpdatePasein from "../../components/AdminFinanceUserFee/FinanceUserFeeUpdate";

export default function UpdatePasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <AdminUpdatePasein/>
    </div>
  );
}
